<!-- INFO -->
<section class="info-section">
  <mat-icon>info_outline</mat-icon>
  <div class="info-text">
    {{ 'map.sidebar.otdr.default.info_section' | translate }}
  </div>
</section>

<!-- FORM -->
<form [formGroup]="form" class="mb-3">
  <!-- device_urn -->
  <mat-form-field appearance="outline">
    <mat-label>{{ 'map.sidebar.otdr.default.form.device_urn_label' | translate }}</mat-label>
    <input
      type="text"
      matInput
      formControlName="device_urn"
      [matAutocomplete]="autoCampo1"
      [placeholder]="'map.sidebar.otdr.default.form.search_placeholder' | translate"
    />
    <mat-autocomplete #autoCampo1="matAutocomplete">
      <mat-option *ngFor="let result of searchResultsDeviceUrn" [value]="result.desc" (click)="handleTree(result)">
        {{ result.desc }}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="form.get('device_urn').hasError('optionError')">
      <ng-container *ngTemplateOutlet="errorOption"></ng-container>
    </mat-error>
    <mat-error *ngIf="form.get('device_urn').hasError('solrError')">
      <ng-container *ngTemplateOutlet="errorSolr"></ng-container>
    </mat-error>
  </mat-form-field>
  <!-- object -->
  <mat-form-field appearance="outline">
    <mat-label>{{ 'map.sidebar.otdr.default.form.object_label' | translate }}</mat-label>
    <input matInput formControlName="object" />
    <mat-error *ngIf="form.get('object').hasError('required')">
      <ng-container *ngTemplateOutlet="errorRequired"></ng-container>
    </mat-error>
  </mat-form-field>
  <!-- ALBERO -->
  <ebw-monorepo-tree
    *ngIf="rootUrn"
    [urn]="rootUrn"
    [type]="'otdr'"
    [selectable]="true"
    [closeTreeAfterSelection]="true"
    [canGoToDetail]="false"
    (selectNode)="handleTreeItemSelection($event)"
    (goToDetail)="goToDetail($event)"
    class="mb-3"
  ></ebw-monorepo-tree>
  <!-- distance -->
  <mat-form-field appearance="outline">
    <mat-label>{{ 'map.sidebar.otdr.default.form.distance_label' | translate }}</mat-label>
    <input matInput type="number" formControlName="distance" placeholder="Es. 100m" />
    <mat-error *ngIf="form.get('distance').hasError('required')">
      <ng-container *ngTemplateOutlet="errorRequired"></ng-container>
    </mat-error>
  </mat-form-field>
</form>

<!-- FORM ERROR TEMPLATES -->
<ng-template #errorRequired>{{ 'map.sidebar.otdr.default.form.error_required' | translate }}</ng-template>
<ng-template #errorSolr>{{ 'map.sidebar.otdr.default.form.error_solr' | translate }}</ng-template>
<ng-template #errorOption>{{ 'map.sidebar.otdr.default.form.error_option' | translate }}</ng-template>

<!-- BUTTONS -->
<ebw-monorepo-as-footer
  [styleContainer]="'buttons-wrapper'"
  [styleWrapper]="'buttons-wrapper'"
  [buttons]="buttons"
  (changeComponentHandler)="onChangeComponentHandler($event)"
></ebw-monorepo-as-footer>

<!-- OTDR RESPONSE DESCRIPTION -->
<section
  id="response-container"
  class="mt-5 d-flex flex-column align-items-start justify-content-start"
  *ngIf="otdrOutcome"
>
  <h4>{{ otdrOutcome.description }}</h4>

  <ng-container *ngIf="otdrOutcome.endPoints as endPoints">
    <div class="d-flex flex-column align-items-start justify-content-end w-100 mb-2" *ngFor="let point of endPoints">
      <div class="d-flex w-100 gap-2">
        <div class="w-100 d-flex flex-column">
          <div>
            Lat: <b class="font-1rem">{{ point?.coordinates[0] | number: '1.0-6' }}</b>
          </div>
          <div>
            Lon: <b class="font-1rem">{{ point?.coordinates[1] | number: '1.0-6' }}</b>
          </div>
        </div>
        <button mat-icon-button (click)="copy(point?.coordinates)" matTooltip="Copia">
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </div>
  </ng-container>
</section>
